import { Flex, Text, Box } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import Error from 'components/Icons/Error';
import Success from 'components/Icons/Success';
import { getPlanPageUiRevampEnabled } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/usePlanPageUiRevamp';

const CustomToastComponent = ({ toast }: any) => {
  const { pathname } = useLocation();
  const flags = useFlags();
  const isPlanRevampUi = getPlanPageUiRevampEnabled(flags) && /\/plan\b/.test(pathname);

  if (!toast?.length) {
    return <></>;
  }
  const getBackground = (alertStatus: string) => {
    if (alertStatus === 'error') return 'red.500';

    return 'green.900';
  };

  const getAlertIcon = (alertStatus: string) => {
    if (alertStatus === 'error') return <Error />;

    return <Success />;
  };

  return (
    <Box
      position={isPlanRevampUi ? 'fixed' : 'absolute'}
      bottom='10px'
      left='50%'
      zIndex={isPlanRevampUi ? '10001' : '9999'}
      style={{ translate: '-50%' }}
      pointerEvents={isPlanRevampUi ? 'none' : undefined}
    >
      {toast.map((data: any, index: number) => {
        return (
          <Flex
            key={index}
            w='75'
            align='center'
            py='3'
            pl='4'
            pr='8'
            borderRadius='md'
            color='white.900'
            bgColor={getBackground(data?.status)}
            boxShadow='lg'
            overflowWrap='break-word'
            overflow='hidden'
            pointerEvents={isPlanRevampUi ? 'auto' : undefined}
          >
            {getAlertIcon(data?.status)}

            <Text ml='2' fontFamily='bold_roboto' fontSize='sm'>
              {data?.message}
            </Text>
          </Flex>
        );
      })}
    </Box>
  );
};
const stateToProperty = (state: any) => {
  return { toast: state?.sharedSlice?.toast };
};
export default connect(stateToProperty)(CustomToastComponent);
